import LoadingButton from "@/components/common/form/loading-button";
import SeoHead from "@/components/common/layout/seo-head";
import Loader from "@/components/common/ui/loader";
import EmptyResult from "@/components/v2/common/v2-empty-result";
import V2EmptyBoxRedIcon from "@/components/v2/icon/v2-empty-box-red-icon";
import { getDefaultLayout } from "@/components/v2/layout/default-layout";
import V2Title from "@/components/v2/layout/v2-title";
import AddTeamModal from "@/components/v2/team/v2-add-team-modal";
import { useOrganizationContext } from "@/context";
import {
  IDefaultLayoutV2Props,
  ILayoutPage,
  V2_DEFAULT_LAYOUT_TYPE,
} from "@/types/layout";
import { PlusSquare } from "lucide-react";
import { useState } from "react";

const V2Home: ILayoutPage<IDefaultLayoutV2Props> = () => {
  const [showAddTeamModal, setShowAddTeamModal] = useState(false);
  const { currentOrganization, isLoading } = useOrganizationContext();

  if (isLoading || currentOrganization) {
    return <Loader size="large" />;
  }

  return (
    <>
      <SeoHead title="코드앤버터" />
      <V2Title title="팀 추가" />
      <div className="flex w-full">
        <div className="mx-auto mt-48 mb-36">
          <EmptyResult
            icon={<V2EmptyBoxRedIcon />}
            reason={<span className="text-error-200">팀이 없어요</span>}
            description={
              <span className="text-error-200">
                코드앤버터의 기능을 이용하시려면 우선 팀 생성이 필요합니다.
              </span>
            }
            fallbackButton={
              <LoadingButton
                theme="danger"
                icon={<PlusSquare width={16} />}
                onClick={() => setShowAddTeamModal(true)}
              >
                팀 추가
              </LoadingButton>
            }
          />
        </div>
      </div>
      <AddTeamModal
        open={showAddTeamModal}
        onClose={() => setShowAddTeamModal(false)}
      />
    </>
  );
};

V2Home.getLayout = getDefaultLayout(V2_DEFAULT_LAYOUT_TYPE.DEFAULT);
export default V2Home;
